
import { useAppDispatch, useAppSelector } from '@/lib/redux/store';
import { useEffect, useState } from 'react';
import { dashboardApi } from "@/api/entity";
import OnboardingChecklist from '@/components/onboarding/OnboardingChecklist';

export default function CustomerOnboarding() {

    const [completedSteps, setCompletedSteps] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [dashboardData, setDashboardData] = useState(null);
    const store = useAppSelector((state) => state.app);
    const { roleActingAs } = store;
    const { entity } = roleActingAs || {};
    const dispatch = useAppDispatch();

    const steps = [
        { id: 'step1', label: 'Upload company logo', link: `/${entity?.slug}/settings` },
        { id: 'step2', label: 'Add your company details', link: `/account` },
        { id: 'step3', label: 'Add your billing details', link: `/${entity?.slug}/billing` },
        { id: 'step4', label: 'Raise your first poll', link: `/${entity?.slug}/polls/create` },
    ];

    useEffect(() => {
        const newCompletedSteps = [];
        if (entity && dashboardData) {
            if (entity.logo) newCompletedSteps.push('step1');
            // check company details
            if (entity.industry_type && entity.address && entity.abn) {
                newCompletedSteps.push('step2');
            }
            if (entity.pm_last_four) newCompletedSteps.push('step3');
            // check if first poll created
            if (dashboardData.polls_created > 0) newCompletedSteps.push('step4');
        }
        setCompletedSteps(newCompletedSteps);
    }, [entity, dashboardData]);

    useEffect(() => {
        if (!entity || isLoading || loaded) return;
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await dashboardApi(entity.slug);
                setDashboardData(response.data.data);
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            } finally {
                setIsLoading(false);
                setLoaded(true);
            }
        };
        fetchData();
    }, [entity, isLoading, loaded]);

    useEffect(() => {
        if (completedSteps.length === steps.length) {
            // update the entity completed_onboarding_steps to true
            dispatch({ 
                type: 'app/setRoleActingAs', 
                payload: {
                    ...roleActingAs ,
                    entity: {
                        ...roleActingAs.entity,
                        completed_onboarding_steps: true
                    }
                } 
            });
        }
    }, [completedSteps.length, steps.length, dispatch, roleActingAs]);

    return (
        <OnboardingChecklist
            completedSteps={completedSteps}
            steps={steps}
        />
    );

}


